import React from 'react';
import home from '../icons/home.svg';
import users from '../icons/users.svg';
import settings from '../icons/settings.svg';
import document from '../icons/document.svg';
import survey from '../icons/survey.svg';
import mail from '../icons/mail.svg';
import log from '../icons/log.svg';
import course from '../icons/course.svg';
import analytics from '../icons/analytics.svg';
import request from '../icons/request.svg';
import profile from '../icons/profile.svg';
import logout from '../icons/logout.svg';

const icons = {
  home,
  users,
  settings,
  document,
  survey,
  mail,
  log,
  course,
  analytics,
  request,
  profile,
  logout
};

export default function Icon({ name, className }) {
  const src = icons[name];
  if (!src) return null;
  return <img src={src} alt="" className={className} />;
}
